// ─── Group Livestream Modal (router) ──────────────────────────────
// Wrapper chọn modal theo typegame trong runningMember.config:
//   - TX → GroupTaixiuLivestreamModal (3 xúc xắc, TÀI/XỈU)
//   - XD → GroupXocdiaLivestreamModal (4 đĩa đỏ/trắng, CHẴN/LẺ)
//   - TL → GroupTulinhLivestreamModal (4 đĩa đỏ/trắng, CHẴN/LẺ)
//
// Giữ cùng API như cũ (isOpen, onClose, groupName, groupId, members) để GroupCard không đổi.

import React from 'react';
import { IAccountDataResponse } from '@tool-no-hu/shared/types';
import { GroupTaixiuLivestreamModal } from './livestream/GroupTaixiuLivestreamModal';
import { GroupXocdiaLivestreamModal } from './livestream/GroupXocdiaLivestreamModal';
import { GroupTulinhLivestreamModal } from './livestream/GroupTulinhLivestreamModal';
import { parseGameType } from '../utils/game';

export interface GroupLivestreamModalProps {
  isOpen: boolean;
  onClose: () => void;
  groupName: string;
  groupId: string;
  members: IAccountDataResponse[];
  gameType?: string;
}

export const GroupLivestreamModal: React.FC<GroupLivestreamModalProps> = ({
  isOpen,
  onClose,
  groupName,
  groupId,
  members,
  gameType,
}) => {
  // Tìm account đang RUNNING để biết typegame (cả group cùng 1 game)
  const runningMember = members.find((m) => m.status === 'RUNNING') ?? members[0];
  const parsed = parseGameType(runningMember?.config);
  const typegame = gameType || (parsed !== '?' ? parsed : '?');

  // Truyền typegame xuống: modal con dùng nó làm khoá SSE dùng chung, cần đúng
  // giá trị đã resolve ở đây chứ không parse lại từ config.
  const sharedProps = { isOpen, onClose, groupName, groupId, members, gameType: typegame };

  if (typegame === 'XD') {
    return <GroupXocdiaLivestreamModal {...sharedProps} />;
  }

  if (typegame === 'TL') {
    return <GroupTulinhLivestreamModal {...sharedProps} />;
  }

  // Mặc định TX (hoặc fallback cho typegame chưa hỗ trợ)
  return <GroupTaixiuLivestreamModal {...sharedProps} />;
};